import { registerFormbrewFormElement } from "./custom-element.ts";
import { installFormbrewStyles } from "./styles.ts";

export { FormbrewError, isFormbrewError, render, version } from "./index.ts";

const currentScript = document.currentScript;

if (currentScript instanceof HTMLScriptElement) {
  installFormbrewStyles(currentScript);
}

registerFormbrewFormElement();
